// extracted by mini-css-extract-plugin
module.exports = {"star":"e3afc254ff--star--Vy8vV","input":"e3afc254ff--input--c0pXb"};